import React from "react";
import "./Header.css";
const Header = () => {
  return (
    <div>
      <div className="card text-center bg-dark text-white">
        <div className="card-body">
          <h3 className="card-title">Learn  Web Development</h3>
          <h4 className="card-text">
          Best youtube channel for learn programming.
                  </h4>
              <h2>Total Cost : 2 Million</h2>
        </div>
        
      </div>
    </div>
  );
};

export default Header;
